import { ApiHandler, createHandlerChainRunnerOptionalParameter } from "@insite/client-framework/HandlerCreator";
import { BillToCollectionModel } from "@insite/client-framework/Types/ApiModels";
import { getCustomBillTos, GetCustomBillTosApiParameter } from "@WhiteCap/Services/CustomCustomerService";

type HandlerType = ApiHandler<GetCustomBillTosApiParameter, BillToCollectionModel>;

export const DispatchBeginLoadBillTos: HandlerType = props => {
    props.dispatch({
        type: "Custom/BillTos/BeginLoadBillTos",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCustomBillTos(props.apiParameter);
};

export const DispatchCompleteLoadBillTosCustom: HandlerType = props => {
    props.dispatch({
        type: "Custom/BillTosWithAccounts/CompleteLoad",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    DispatchBeginLoadBillTos,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadBillTosCustom,
];

const loadCustomBillTos = createHandlerChainRunnerOptionalParameter(chain, {}, "LoadCustomBillTos");
export default loadCustomBillTos;
